const routerArr = [
    {
        path: '/address/list',
        name: 'addressList',
        meta: { title:'收货地址',login: false },
        component: () => import(/* webpackChunkName: 'address' */ './page/list.vue'),
    },
    {
        path: '/address/add',
        name: 'addressAdd',
        meta: { title:'新增地址',login: false },
        component: () => import(/* webpackChunkName: 'address' */ './page/form.vue'),
    },
    {
        path: '/address/edit/:id',
        name: 'addressEdit',
        meta: { title:'编辑地址',login: false },
        component: () => import(/* webpackChunkName: 'address' */ './page/form.vue'),
    },
  ]
  export default routerArr 